<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="550px"
    class=""
  >
    <v-card class="">
      <!-- <v-container class="pa-2" fluid> -->
      <v-card-title class="d-flex justify-space-between align-start">
        <!-- Left side -->
        <div>
          <div class="text-h6 font-weight-medium">
            {{ appRelease.id ? "Edit release" : "Add release" }}
          </div>
          <div
            v-if="appRelease.id"
            class="text-caption text--secondary mt-1"
          >
            Engine v{{ appRelease.engine_version }}
          </div>
        </div>
        <!-- Right side badges -->
        <div
          class="d-flex pb-3"
          style="gap: 8px;"
        >
          <v-chip
            v-if="appRelease.id && appRelease.pos_version"
            small
            outlined
            color="purple"
          >
            POS v{{ appRelease.pos_version }}
          </v-chip>
          <v-chip
            v-if="appRelease.id && appRelease.kds_version"
            small
            outlined
            color="teal"
          >
            KDS v{{ appRelease.kds_version }}
          </v-chip>
          <v-chip
            v-if="appRelease.id && appRelease.kiosk_version"
            small
            outlined
            color="orange"
          >
            Kiosk v{{ appRelease.kiosk_version }}
          </v-chip>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 ">
        <v-form
          ref="appRelease"
          v-model="isValid"
          lazy-validation
        >
          <v-row class="mt-n1">
            <v-col
              cols="12"
              md="4"
            >
              <span>Version
                <span class="red--text">*</span>
              </span>
              <v-text-field
                v-model="appRelease.engine_version"
                required
                :rules="rules"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <span>Pos Version
                <span class="red--text">*</span>
              </span>
              <v-text-field
                v-model="appRelease.pos_version"
                required
                :rules="rules"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <span>
                Kds Version
                <span class="red--text">*</span>
              </span>
              <v-text-field
                v-model="appRelease.kds_version"
                required
                :rules="rules"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <span>Kiosk Version</span>
              <v-text-field
                v-model="appRelease.kiosk_version"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row class="mt-n4">
            <v-col cols="12">
              <div
                class="d-flex justify-space-between mb-2"
                style="gap: 6px;"
              >
                <span>Releases Notes</span>
                <div>
                  <v-btn
                    v-for="tag in noteTags"
                    :key="tag.label"
                    x-small
                    outlined
                    color="grey"
                    class="mr-2"
                    @click="insertTag(tag.text)"
                  >
                    + {{ tag.label }}
                  </v-btn>
                </div>
              </div>
              <v-textarea
                ref="notesRef"
                v-model="appRelease.notes"
                rows="5"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="">
        <div>
          <small style="font-weight: 400; margin-right: 4px">
            <span class="red--text">*</span>
            indicates required field</small>
        </div>
        <v-spacer />
        <v-btn
          color="error"
          class="white--text"
          @click.native="close()"
        >
          Close
        </v-btn>
        <v-btn
          color="success"
          class="white--text"
          :disabled="!isValid"
          :loading="loader"
          @click.native="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
      <!-- </v-container> -->
    </v-card>
  </v-dialog>
</template>
<script>
import { failure, pagination } from "@/mixins/common";
export default {
  name: "NewDigitoryApp",
  mixins: [failure, pagination],
  props: {
    editRelease: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      appRelease: {
        id: null,
        engine_version: null,
        pos_version: null,
        kds_version: null,
        kiosk_version: null,
        notes: null
      },
      loader: false,
      isValid: false,
      rules: [v => !!v || "Field is required"],
      noteTags: [
        { label: "New", text: "**New**" },
        { label: "Fixed", text: "**Fixed**" },
        { label: "Improved", text: "**Improved**" }
      ]
    };
  },
  watch: {
    editRelease: {
      handler(newVal) {
        if (newVal) {
          this.appRelease = { ...newVal };
          this.dialog = true;
        }
      },
      deep: true
    }
  },
  methods: {
    resetApp() {
      this.appRelease = {
        id: null,
        engine_version: null,
        pos_version: null,
        kds_version: null,
        kiosk_version: null,
        notes: null
      };
      if (this.$refs.appRelease) {
        this.$refs.appRelease.resetValidation();
      }
    },
    open() {
      this.resetApp();
      this.dialog = true;
    },
    save() {
      if (!this.$refs.appRelease.validate()) {
        return;
      }
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/appReleases`;
      if (this.appRelease.id) {
        url += `/${this.appRelease.id}`;
        this.$http.put(url, this.appRelease).then(
          response => {
            this.loader = false;
            this.close();
            this.handleSuccess(response);
          },
          failure => {
            this.loader = false;
            this.handleFailure(failure);
          }
        );
        return;
      }
      this.$http.post(url, this.appRelease).then(
        response => {
          this.loader = false;
          this.close();
          this.handleSuccess(response);
        },
        failure => {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    close() {
      this.dialog = false;
      this.resetApp();
      this.$emit("refresh");
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.body.message
      });
    },
    insertTag(tag) {

      const ta = this.$refs.notesRef?.$el?.querySelector("textarea");
      if (!ta) return;

      const start = ta.selectionStart;
      const value = this.appRelease.notes || "";

      const before = value.substring(0, start);
      const after = value.substring(start);

      const prefix = before.length > 0 && !before.endsWith("\n") ? "\n" : "";

      const newValue = before + prefix + tag + " — " + after;

      this.appRelease.notes = newValue; // FIXED

      this.$nextTick(() => {
        const pos = (before + prefix + tag + " — ").length;
        ta.focus();
        ta.setSelectionRange(pos, pos);
      });
    }
  }
};
</script>
